import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppRoutes from './routes/AppRoutes';

import './App.css';
import './assets/css/sidebar.css';
import './assets/css/Dashboard.css';
import './assets/css/main.css';
import './assets/css/RedirectPage.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import CustomNavbar from './pages/user-managemnet/PublicNavbar';
import { Route, createBrowserRouter, RouterProvider, createRoutesFromElements, Outlet } from 'react-router-dom';
import ProtectedRoutes from './ProtectedRoute';
import Dashboard from './pages/dashboard/Dashboard';
// import PlansPage from './pages/dashboard/PlansPage';
import OtpPage from './pages/user-managemnet/OtpPage';
import LoginPage from './pages/user-managemnet/LoginPage';
import SignupPage from './pages/user-managemnet/SignupPage';
import HomePage from './pages/website-pages/HomePage';
import PlansPage from './pages/plan/PlansPage';
import LinkAnalysis from './pages/link/LinkAnalysis';
import ShortLink from './pages/link/ShortLink';
import LinkGenerator2 from './pages/link/LinkGenerator2';
import BiolLinkPage from './pages/biolink-page/BiolLinkPage';
import FollowersList from './pages/followers/FollowersList';
import UserBiolLinkPage from './pages/user-managemnet/UserBiolLinkPage';
import ProfileAnalytics from './pages/profile-analytics/ProfileAnalytics';
import AboutUs from './pages/user-managemnet/AboutUs';
import PrivacyPolicy from './pages/user-managemnet/PrivacyPolicy';
import CookiesPolicy from './pages/user-managemnet/CookiesPolicy';
import ContentPolicy from './pages/user-managemnet/ContentPolicy';
import TermAndConditions from './pages/user-managemnet/TermCondition';
import ContactUs from './pages/user-managemnet/ContactUs';
import VideoAnalysis from './pages/profile-analytics/YoutubeAnalytics';
import ButtonAnalytics from './pages/profile-analytics/ButtonAnalytics';
import ForgotPassword from './pages/user-managemnet/ForgotPassword';
import ChangePassword from './pages/user-managemnet/ChangePassword';
import CookieConsentBanner from './pages/user-managemnet/CookieConsentBanner';
import ChatList from './pages/followers/ChatList'
import PaymentList from './pages/payment-list/PaymentList';
import CheckoutPage from './pages/plan/CheckoutPage';
// import LinkGenerator from './pages/dashboard/LinkGenerator';
// import LinkGenerator2 from './pages/dashboard/LinkGenerator2';
// import LinkAnalysis from './pages/dashboard/LinkAnalysis';

function PublicLayout() {
  return (
    <>
      <Outlet />
      <CookieConsentBanner />
    </>
  );
}

const routes = createRoutesFromElements(
  <>
    <Route element={<PublicLayout />}>
      <Route path="/" element={<HomePage />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/otp-verify" element={<OtpPage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path='/reset-password' element={<ChangePassword />} />
      <Route path='/o/:id' element={<LinkGenerator2 />} />
      <Route path='/x/:id' element={<UserBiolLinkPage />} />
      <Route path='/about-us' element={<AboutUs />} />
      <Route path='/contact-us' element={<ContactUs />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/cookies-policy' element={<CookiesPolicy />} />
      <Route path='/content-policy' element={<ContentPolicy />} />
      <Route path='/terms-and-conditions' element={<TermAndConditions />} />
    </Route>
    <Route element={<ProtectedRoutes />}>
      <Route path='/dashboard' element={<Dashboard />} />
      <Route path='/checkout-page' element={<CheckoutPage />} />
      <Route path='/plans' element={<PlansPage />} />
      <Route path='/short-links' element={<ShortLink />} />
      <Route path='/link-analysis' element={<LinkAnalysis />} />
      <Route path='/bio-page' element={<BiolLinkPage />} />
      <Route path='/connection-management' element={<FollowersList />} />
      <Route path='/chat-list' element={<ChatList />} />
      <Route path='/profile-analytics-list' element={<ProfileAnalytics />} />
      <Route path='/video-analytics' element={<VideoAnalysis />} />
      <Route path='/button-analytics' element={<ButtonAnalytics />} />
      <Route path='/payment-history' element={<PaymentList />} />
    </Route>
  </>
);

const router = createBrowserRouter(routes);

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
      offset: 100,
    });
  }, []);

  return (
    <div className="App">
      <RouterProvider router={router} />
      <ToastContainer />
    </div>
  );
}

export default App;
